module.exports = __webpack_public_path__ + "static/media/pickupTimelineIcon.667dc9d6.svg";